import { render, staticRenderFns } from "./supplementary-info.vue?vue&type=template&id=1df15190&scoped=true&"
import script from "./supplementary-info.vue?vue&type=script&lang=js&"
export * from "./supplementary-info.vue?vue&type=script&lang=js&"
import style0 from "./supplementary-info.vue?vue&type=style&index=0&id=1df15190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df15190",
  null
  
)

export default component.exports